import { render } from "./commonParts.vue?vue&type=template&id=0f030d03&scoped=true&ts=true"
import script from "./commonParts.vue?vue&type=script&lang=ts"
export * from "./commonParts.vue?vue&type=script&lang=ts"

import "./commonParts.vue?vue&type=style&index=0&id=0f030d03&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f030d03"]])

export default __exports__